var map = {
	"./bh-ico-active.svg": 1778,
	"./bh-ico.svg": 1779,
	"./bonus-ico-active.svg": 1780,
	"./bonus-ico.svg": 1781,
	"./deposit-ico.svg": 1782,
	"./deposit-ico.webp": 1783,
	"./edit-icon.svg": 1784,
	"./fb-ico.svg": 1785,
	"./instant-rebate-ico-active.svg": 1786,
	"./instant-rebate-ico.svg": 1787,
	"./mall-ico-active.svg": 1788,
	"./mall-ico.svg": 1789,
	"./msg-ico-active.svg": 1790,
	"./msg-ico.svg": 1791,
	"./pi-ico-active.svg": 1792,
	"./pi-ico.svg": 1793,
	"./rf-ico-active.svg": 1794,
	"./rf-ico.svg": 1795,
	"./rh-ico-active.svg": 1796,
	"./rh-ico.svg": 1797,
	"./th-ico-active.svg": 1798,
	"./th-ico.svg": 1799,
	"./vip-ico-active.svg": 1800,
	"./vip-ico.svg": 1801,
	"./withdrawal-ico.svg": 1802,
	"./withdrawal-ico.webp": 1803,
	"./wl-ico-active.svg": 1804,
	"./wl-ico.svg": 1805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;